import { render, staticRenderFns } from "./AxisY1.vue?vue&type=template&id=d379cf3c&"
import script from "./AxisY1.vue?vue&type=script&lang=ts&"
export * from "./AxisY1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports